import { useMutation } from "urql";

import { HandoverLimitRequestToCuDocument } from "../../../graphql/generated.ts";

export const useHandoverLimitRequestToCU = () =>
  useMutation(HandoverLimitRequestToCuDocument);
